export { default as EducaeetHero } from "./educaeethero/EducaeetHero";
export { default as EducaeetHeroEdit } from "./educaeethero/EducaeetHeroEdit";
export { default as EducaeetCategoryGrid } from "./educaeetcategories/EducaeetCategoryGrid";
export { default as EducaeetCategoriesEdit } from "./educaeetcategories/EducaeetCategoriesEdit";
export { default as EducaeetStats } from "./educaeetstats/EducaeetStats";
export { default as EducaeetStatsEdit } from "./educaeetstats/EducaeetStatsEdit";
export { default as EducaeetTestimonials } from "./educaeettestimonials/EducaeetTestimonials";
export { default as EducaeetTestimonialsEdit } from "./educaeettestimonials/EducaeetTestimonialsEdit";
export { default as EducaeetCTA } from "./educaeetcta/EducaeetCTA";
export { default as EducaeetCTAEdit } from "./educaeetcta/EducaeetCTAEdit";
export { EducaeetFooter } from "./educaeetfooter/EducaeetFooter";
export { default as EducaeetFooterEdit } from "./educaeetfooter/EducaeetFooterEdit";
